module.exports = __webpack_public_path__ + "static/media/html.6f2ef579.svg";